<template>
  <div class="p-5"> 
    <aron-table :showActionButton="showActionButton" :viewOnly="viewOnly" uploadEndpoint="/uploadFile" :endPoint="route" :filterEndpoint="filterEndpoint" :key="route" :formType="formType"></aron-table>
  </div>
</template> 
 
<script>
import AronTable from "../../components/aron/table/tblmain.vue";
export default {
  components: {
    AronTable
  },

  data() {
    return { route: this.$route.params.endPoint, formType: "sidebarRightSide" };
  },

  computed:{
      filterEndpoint(){
        return "search_" + this.route;
      },
      viewOnly(){
        if(this.route == "recepients" || this.route == "sendinglogs"){
          return true
        }

        return false;
      },
      showActionButton(){
        if(this.route == "recepients" || this.route == "sendinglogs"){
          return false
        }

        return true;
      }
  },

  watch:{
    '$route'(to, from){
      this.route = to.params.endPoint
       this.formType = "sidebarRightSide"
    }
  }
};
</script>

